// extracted by mini-css-extract-plugin
export default {"root":"Login_root__aW1-O","header":"Login_header__21Fom","avatar":"Login_avatar__jwrSO","captcha":"Login_captcha__B5Pkt"};